module.exports = __webpack_public_path__ + "img/266191.2ea0e3e5.svg";